



























import {Component, Ref, Vue, Watch} from 'vue-property-decorator';
import {Nametag} from "@/design-system/constructs/Nametag/nametag.entity"
import faker from "@faker-js/faker"


function build() {
    const name = [faker.name.firstName(), faker.name.lastName()]
    return {
        name: faker.name.findName(name[0], name[1]),
        email: faker.internet.email(name[0], name[1]),
        avatar: faker.internet.avatar(),
        avatarColor: faker.internet.color(),
        isJobillaStaff: true,
        unit: 'Jobilla Finland',
        team: 'foo',
        role: 'bar',
        joinedAt: faker.date.past(5),
        lastActiveAt: faker.date.recent(3),
    }
}

@Component({
    components: { }
})
export default class JdpTestAdmin extends Vue {
    form = {
        email: '',
        user: 0
    }

    users: Array<Nametag> = [build(),build(),build(),build(),build(),build(),build(),build()]

    saving = false

    save() {
        this.saving = true
        setTimeout(() => {
            this.saving = false
        }, 500)
    }

    mounted() {
    }
}
